import type { MenuProps } from 'react-aria-components';
import { Menu as AriaMenu } from 'react-aria-components';

import { composeTailwindRenderProps } from '../utils.ts';
import { menuStyles } from './menu-styles.ts';

export function Menu<T extends object>({ className, ...props }: MenuProps<T>) {
  return (
    <AriaMenu
      {...props}
      className={composeTailwindRenderProps(
        className,
        menuStyles(),
      )}
    />
  );
}
